var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, createRef } from "react";
import { cn } from "@discovery/classnames";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { compose } from "@discovery/prelude/lib/data/function";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import * as Routes from "@discovery/sonic-api-ng/lib/api/cms/routes";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as CQ from "@discovery/sonic-api-ng/lib/api/common/query";
import { Spinner } from "../../components/atoms/spinner";
import { Carousel } from "../../components/ecosystem/carousel";
import InterstitialsAds from "../../components/molecules/interstials-ads";
import { RailTypes } from "../rails";
import { TaxonomyTemplate } from "../../components/molecules/taxonomy";
import { Toast } from "../../components/molecules/toast";
import { Rails } from "../../components/organisms/rails";
import TaxonomyItems from "../../components/organisms/taxonomy-items";
import { RailsOne } from "../../components/atoms/shimmer";
import { _RailsData, _RailTitle, _CollectionAlias, _TemplateId, _HeroRailData, HeroSuperStarRails, _GridId, RailTemp, VideoRail, _PosterData, } from "./optics";
import LiveTvMastHead from "../../components/molecules/liveTvMasthead";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import CampaignLandingPage from "../../components/molecules/campaign-landing";
import { getFavItem } from "../../utils/getFav";
import * as styles from "./styles.css";
export var HeroTemplateId;
(function (HeroTemplateId) {
    HeroTemplateId["BASIC"] = "basic";
    HeroTemplateId["CAMPAIGN_HEADER"] = "campaign-header";
})(HeroTemplateId || (HeroTemplateId = {}));
export class HeroView extends Component {
    constructor(props) {
        super(props);
        this.io = new IntersectionObserver(() => { });
        this.nextPageElem = createRef();
        this.fetchRails = () => __awaiter(this, void 0, void 0, function* () {
            const defaultDecorators = CQ.Decorators.concat(CQ.Decorators.decorators("isFavorite"), CQ.Decorators.decorators("viewingHistory"));
            const request = Routes.Endpoints.getRoute("home", compose(Routes.Query.lenses.decorators.set(defaultDecorators), Routes.Query.lenses.page.set(CQ.Pages.pages(CQ.Page.page(CQ.Page.ItemsIndex.NUMBER, this.state.pageNumber), CQ.Page.page(CQ.Page.ItemsIndex.SIZE, 6))))(Routes.Query.parameters));
            yield App.run(request)(Object.assign(Object.assign(Object.assign({}, envBrowser), this.props.read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, (response) => {
                const resp = Fold.toArray(_RailsData, response);
                const updatedRail = this.testrenderRailBasedonTempId(resp);
                this.setState({
                    isDataAvailable: false,
                });
                this.setState({
                    railResultsForWeb: updatedRail,
                });
                if (this.nextPageElem.current)
                    this.io.observe(this.nextPageElem.current);
            }));
        });
        this.componentDidMount = () => {
            this.fetchRails();
            const url = config.shareBaseURL + config.standardPageRouteFragments.home;
            let branch;
            const linkData = {
                data: {
                    $desktop_url: url,
                    $canonical_identifier: url,
                    $canonical_url: url,
                    $deeplink_path: url,
                },
            };
            branch && branch.setBranchViewData && branch.setBranchViewData(linkData);
            this.io = new IntersectionObserver(this.fetchDataPagination, {
                threshold: 1,
            });
        };
        this.fetchDataPagination = (entries) => {
            if ((entries[0] && !entries[0].isIntersecting) ||
                this.state.fetchingPagination) {
                return;
            }
            this.setState({
                fetchingPagination: true,
                pageNumber: this.state.pageNumber + 1,
            }, () => {
                this.getRailsOnScroll();
            });
        };
        this.getRailsOnScroll = () => __awaiter(this, void 0, void 0, function* () {
            const defaultDecorators = CQ.Decorators.concat(CQ.Decorators.decorators("isFavorite"), CQ.Decorators.decorators("viewingHistory"));
            const request = Routes.Endpoints.getRoute("home", compose(Routes.Query.lenses.decorators.set(defaultDecorators), Routes.Query.lenses.page.set(CQ.Pages.pages(CQ.Page.page(CQ.Page.ItemsIndex.NUMBER, this.state.pageNumber), CQ.Page.page(CQ.Page.ItemsIndex.SIZE, 6))))(Routes.Query.parameters));
            yield App.run(request)(Object.assign(Object.assign(Object.assign({}, envBrowser), this.props.read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, (response) => {
                const resp = Fold.toArray(_RailsData, response);
                const updatedRail = this.testrenderRailBasedonTempId(resp);
                if (this.nextPageElem.current)
                    this.io.observe(this.nextPageElem.current);
                if (updatedRail.length === 0) {
                    this.io.disconnect();
                }
                this.appendRail(updatedRail);
                this.setState({
                    updatedRail,
                    fetchingPagination: false,
                });
            }));
        });
        this.testrenderRailBasedonTempId = (data) => {
            let cardArray;
            const updatedRailList = [];
            data.map((item) => {
                const titleM = Fold.preview(Fold.compose(_RailTitle, M._Just()), item);
                const aliasM = Fold.preview(_CollectionAlias, item);
                const alias = M.fromMaybe(aliasM, "");
                const templateIdM = Fold.preview(_TemplateId, item);
                const templateId = M.fromMaybe(templateIdM, "");
                const contentGridIdM = Fold.preview(_GridId, item);
                const gridID = M.fromMaybe(contentGridIdM, "");
                const mapComponentIdToTemplateId = () => {
                    switch (alias) {
                        case "discovery-superstars":
                            return "carousel-superstar";
                        case "featured-standalone":
                            return "featured-standalone";
                        default:
                            return templateId;
                    }
                };
                const tempId = mapComponentIdToTemplateId();
                const continueWatchCards = Fold.toArray(VideoRail, item).filter((item) => {
                    const viewingHistoryM = item.viewingHistoryM;
                    const viewingHistory = viewingHistoryM &&
                        M.fromMaybe(viewingHistoryM, {
                            viewed: false,
                        });
                    const vType = M.fromMaybe(item.videoType, "");
                    return (viewingHistory.viewed === true &&
                        vType !== "LIVE" &&
                        vType !== "CLIP");
                });
                switch (tempId) {
                    case "basic":
                    case "featured-standalone":
                        cardArray = {
                            title: M.fromMaybe(titleM, ""),
                            type: M.of(tempId),
                            cardData: Fold.toArray(_HeroRailData, item),
                            id: gridID,
                        };
                        updatedRailList.push(cardArray);
                        break;
                    case "carousel-superstar":
                        cardArray = {
                            title: M.fromMaybe(titleM, ""),
                            type: M.of("carousel-superstar"),
                            cardData: Fold.toArray(HeroSuperStarRails, item),
                            id: gridID,
                        };
                        updatedRailList.push(cardArray);
                        break;
                    case "basic-with-position":
                        cardArray = {
                            title: M.fromMaybe(titleM, ""),
                            type: Fold.preview(_TemplateId, item),
                            cardData: Fold.toArray(_HeroRailData, item),
                            id: gridID,
                        };
                        updatedRailList.push(cardArray);
                        break;
                    case "square-title-compact":
                        cardArray = {
                            title: M.fromMaybe(titleM, ""),
                            type: Fold.preview(RailTemp, item),
                            cardData: Fold.toArray(_PosterData, item),
                            id: gridID,
                        };
                        updatedRailList.push(cardArray);
                        break;
                    case "descriptive-with-progress":
                        cardArray = {
                            title: M.fromMaybe(titleM, ""),
                            type: Fold.preview(RailTemp, item),
                            cardData: continueWatchCards,
                            id: gridID,
                        };
                        updatedRailList.push(cardArray);
                        break;
                    default:
                        cardArray = {
                            title: M.fromMaybe(titleM, ""),
                            type: Fold.preview(_TemplateId, item),
                            cardData: Fold.toArray(_HeroRailData, item),
                            id: gridID,
                        };
                        updatedRailList.push(cardArray);
                        break;
                }
            });
            return updatedRailList;
        };
        this.appendRail = (rails) => {
            const { railResultsForWeb } = this.state;
            const updatedRail = railResultsForWeb.concat(rails);
            this.setState({ railResultsForWeb: updatedRail });
        };
        this.setToastMsg = (message, successFlag) => {
            this.setState({
                toastMsg: message,
                isToastMsg: true,
                successFlag: successFlag,
            });
            setTimeout(() => {
                this.setState({
                    isToastMsg: false,
                });
            }, 2000);
        };
        this.toastHandler = () => {
            this.setState({ isToastMsg: false });
        };
        this.templateIdToRailType = (templateId) => {
            switch (templateId) {
                case "basic":
                    return RailTypes.Basic;
                case "basic-with-position":
                    return RailTypes.BasicWithPosition;
                case "carousel-superstar":
                    return RailTypes.SuperStars;
                case "square-title-compact":
                    return RailTypes.Poster;
                case "descriptive-with-progress":
                    return RailTypes.DescriptiveWithProgress;
                case "descriptive":
                    return RailTypes.Descriptive;
                case "single-item":
                    return RailTypes.PremiumCarousel;
                case "pwa-rectangle":
                    return RailTypes.CategoryCard;
                case "vertical-poster-large":
                    return RailTypes.Basic;
                case "featured-standalone":
                    return RailTypes.FeaturedStandalone;
                default:
                    return RailTypes.Basic;
            }
        };
        this.renderMastHead = () => {
            const { heroItems, templateIdM, premiumPackages, ageConstraint, resizeWidth, liveTvVideoDataM, read, genre, descriptionM, imaAdsConfig, componentIdM, campaignLandingBannerM, } = this.props;
            const templateId = M.fromMaybe(templateIdM, "");
            switch (templateId) {
                case HeroTemplateId.CAMPAIGN_HEADER:
                    return (React.createElement(CampaignLandingPage, { campaignLandingBannerM: campaignLandingBannerM }));
                case "video-campaign-header":
                    return (React.createElement(LiveTvMastHead, { read: read, liveTvVideoDataM: liveTvVideoDataM, genre: genre, descriptionM: descriptionM, imaAdsConfig: imaAdsConfig }));
                default:
                    return (React.createElement(Carousel, { heroItems: heroItems, autoplay: 5000, loop: heroItems.length > 1, templateIdM: templateIdM, componentIdM: componentIdM, premiumPackages: premiumPackages, resizeWidth: resizeWidth, ageConstraint: ageConstraint }));
            }
        };
        this.state = {
            startIndex: 0,
            endIndex: 3,
            cardArray: [],
            railResultsForWeb: [
                {
                    title: "",
                    type: M.of(""),
                    cardData: [],
                    id: "",
                },
            ],
            updatedRail: [
                {
                    title: "",
                    type: M.of(""),
                    cardData: [],
                    id: "",
                },
            ],
            toastMsg: "",
            isToastMsg: false,
            successFlag: false,
            fetchingPagination: false,
            cardReset: false,
            pageNumber: 1,
            isDataAvailable: true,
        };
    }
    render() {
        const { webAuthRedirectionUrl, taxonomyItemsListHero, ageConstraint, isAdsEnabled, templateIdM, read, } = this.props;
        const { railResultsForWeb, fetchingPagination, isDataAvailable } = this.state;
        const isValidTrigger = localStorage.getItem("isValidTrigger");
        const showInterstitialAd = isValidTrigger && JSON.parse(isValidTrigger);
        const templateId = M.fromMaybe(templateIdM, "");
        getFavItem(read);
        return (React.createElement(React.Fragment, null,
            isAdsEnabled && showInterstitialAd && React.createElement(InterstitialsAds, null),
            React.createElement("div", { className: cn(styles.mastheadContainer, {
                    [styles.liveTvMastheadContainer]: templateId === "video-campaign-header",
                }) }, this.renderMastHead()),
            templateId === HeroTemplateId.BASIC ? (React.createElement(TaxonomyItems, { taxonomyItemsListHero: taxonomyItemsListHero, hideTaxonomyImage: false, template: TaxonomyTemplate.HERO })) : (React.createElement(React.Fragment, null)),
            railResultsForWeb &&
                railResultsForWeb.length > 0 &&
                railResultsForWeb.map((item, index) => {
                    const railTemplate = this.templateIdToRailType(M.fromMaybe(item.type, ""));
                    return (item.cardData &&
                        item.cardData.length > 0 && (React.createElement(Rails, { cards: item.cardData.map((item) => item), title: item.title, railType: railTemplate, webAuthRedirectionUrl: webAuthRedirectionUrl, gridID: item.id, ageConstraint: ageConstraint, viewAllRouteM: M.of(""), key: index, BannerId: item.bannerId, bannerAdPlaceholder: item.backUpAd, isAdsEnabled: isAdsEnabled, read: this.props.read })));
                }),
            isDataAvailable && (React.createElement("div", { className: styles.shimmerForRails },
                React.createElement(RailsOne, null))),
            React.createElement("div", { ref: this.nextPageElem }, fetchingPagination && (React.createElement("div", { className: styles.loader },
                React.createElement(Spinner, null)))),
            this.state.isToastMsg && (React.createElement(Toast, { toastMsg: this.state.toastMsg, successFlag: this.state.successFlag, onClick: this.toastHandler }))));
    }
}

